(() => {
    window.Dashboard = window.Dashboard || {};

    window.Dashboard.Models = window.Dashboard.Models || {};

    /**
     * The Campaign Template Communication model for Yumbi Campaigns
     * @constructor
     */
    class TextMessage {
        Text;
        ExclusionRule;

        /**
         * @param {string} [text]
         */
        constructor(text) {
            this.Text = text || "";
            this.ExclusionRule = new window.Dashboard.Models.ExclusionRules()
        }

        /**
         * Initialises the campaign with the campaign returned from the API
         */
        initialiseTextMessage(textMessage) {
            return _.extend(self, textMessage);
        };
    }

    window.Dashboard.Models.TextMessage = TextMessage;
})();
